var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUlx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 13,
    viewBox: "0 0 45 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38725 12.5L6.61125 4.004H8.41925L10.2033 11.796L9.79525 11.812L10.9073 4.004H13.4673L11.7713 12.5H8.38725ZM2.48325 12.5L0.787251 4.004H3.34725L4.45925 11.812L4.05925 11.796L5.82725 4.004H7.63525L5.87525 12.5H2.48325ZM23.8246 8.236C23.8246 9.72933 23.43 10.8467 22.6406 11.588C21.8513 12.324 20.7713 12.692 19.4006 12.692C18.0246 12.692 16.942 12.324 16.1526 11.588C15.3686 10.8467 14.9766 9.72933 14.9766 8.236C14.9766 8.03333 14.9766 7.81733 14.9766 7.588C14.9766 7.35867 14.9766 7.11867 14.9766 6.868V0.7H17.4646V7.22C17.4646 7.42267 17.4646 7.612 17.4646 7.788C17.4646 7.964 17.4646 8.12667 17.4646 8.276C17.4646 9.108 17.6166 9.72133 17.9206 10.116C18.2246 10.5053 18.718 10.7 19.4006 10.7C20.078 10.7 20.5713 10.5053 20.8806 10.116C21.19 9.72133 21.3446 9.108 21.3446 8.276V0.7H23.8246V8.236ZM26.1091 12.5V0.7H28.5971V11.756L27.4771 10.476H32.9891V12.5H26.1091ZM38.1786 5.66L38.1626 7.668L34.3386 0.7H37.1306L39.6826 6.012H38.6986L41.2266 0.7H44.0186L40.2346 7.668L40.2186 5.66L44.1386 12.5H41.3386L38.6586 7.316H39.7146L37.0346 12.5H34.2426L38.1786 5.66Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlx);
export default __webpack_public_path__ + "static/media/ULX.f583a03824b14172398f8fd579c44432.svg";
export { ForwardRef as ReactComponent };